import { Action } from "@ngrx/store";
import { SearchFeatureChecks } from "../../../shared/models/b2b/searchFeatureChecks";
import { SearchParams } from "../../../shared/models/b2b/searchParams";
import { SearchType } from "../../../shared/models/b2b/searchType";
import { RouterState } from "../../router/router.state";

export enum MainActionTypes {
    DO_GET_BRANDS = "[Main] Get Brands",
    DO_GET_BRANDS_OK = "[Main] Get Brands OK",
    DO_GET_BRANDS_KO = "[Main] Get Brands KO",

    DO_GET_ALLBRANDS = "[Main] Get All Brands",
    DO_GET_ALLBRANDS_OK = "[Main] Get All Brands OK",
    DO_GET_ALLBRANDS_KO = "[Main] Get All Brands KO",

    DO_GET_REPLACEMENTORDERS = "[Main] Get All Replacement Orders",
    DO_GET_REPLACEMENTORDERS_OK = "[Main] Get All Replacement Orders OK",
    DO_GET_REPLACEMENTORDERS_KO = "[Main] Get All Replacement Orders KO",

    DO_GET_FEATURE_OPTIONS = "[Main] Get Feature Options",
    DO_GET_FEATURE_OPTIONS_OK = "[Main] Get Feature Options OK",
    DO_GET_FEATURE_OPTIONS_KO = "[Main] Get Feature Options KO",
    DO_GET_FEATURE_CHECKS = "[Main] Get Feature Checks",
    DO_GET_FEATURE_CHECKS_OK = "[Main] Get Feature Checks OK",
    DO_GET_FEATURE_CHECKS_KO = "[Main] Get Feature Checks KO",
    DO_RESET_FEATURE_CHECKS = "[Main] Reset Feature Checks",
    DO_GET_INFO_INVOICES = "[Main] Get Info Invoices",
    DO_GET_INFO_INVOICES_OK = "[Main] Get Info Invoices OK",
    DO_GET_INFO_INVOICES_KO = "[Main] Get Info Invoices KO",
    DO_GET_INFO_ORDERS = "[Main] Get Info Orders",
    DO_GET_INFO_ORDERS_OK = "[Main] Get Info Orders OK",
    DO_GET_INFO_ORDERS_KO = "[Main] Get Info Orders KO",
    DO_GET_BANNERS = "[Main] Get Banners",
    DO_GET_BANNERS_OK = "[Main] Get Banners OK",
    DO_GET_BANNERS_KO = "[Main] Get Banners KO",
    DO_SET_MENU_ITEM = "[Main] Set Menu Item",
    DO_SET_PRE_LOGIN_PARAMS = "[Main] Set PreLogin Params",
    DO_SET_FORCE_SEARCH_TYPE_FLAG = "[Main] Set Force SearchType Flag",
}

// Invoices
export class DoGetInfoInvoices implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_INVOICES;

    constructor() {}
}

export class DoGetInfoInvoicesOK implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_INVOICES_OK;

    constructor(public payload: any) {}
}

export class DoGetInfoInvoicesKO implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_INVOICES_KO;

    constructor(public payload: any) {}
}

// Orders
export class DoGetInfoOrders implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_ORDERS;

    constructor() {}
}

export class DoGetInfoOrdersOK implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_ORDERS_OK;

    constructor(public payload: any) {}
}

export class DoGetInfoOrdersKO implements Action {
    readonly type = MainActionTypes.DO_GET_INFO_ORDERS_KO;

    constructor(public payload: any) {}
}

// Brands
export class DoGetBrands implements Action {
    readonly type = MainActionTypes.DO_GET_BRANDS;

    constructor(
        public payload: {
            type: string;
        }
    ) {}
}

export class DoGetBrandsOK implements Action {
    readonly type = MainActionTypes.DO_GET_BRANDS_OK;

    constructor(public payload: any) {}
}

export class DoGetBrandsKO implements Action {
    readonly type = MainActionTypes.DO_GET_BRANDS_KO;

    constructor(public payload: any) {}
}

// AllBrands
export class DoGetAllBrands implements Action {
    readonly type = MainActionTypes.DO_GET_ALLBRANDS;

    constructor(
        public payload: {
            type: string;
        }
    ) {}
}

export class DoGetAllBrandsOK implements Action {
    readonly type = MainActionTypes.DO_GET_ALLBRANDS_OK;

    constructor(public payload: any) {}
}

export class DoGetAllBrandsKO implements Action {
    readonly type = MainActionTypes.DO_GET_ALLBRANDS_KO;

    constructor(public payload: any) {}
}

// ReplacementOrders
export class DoGetAllReplacementOrders implements Action {
    readonly type = MainActionTypes.DO_GET_REPLACEMENTORDERS;

    constructor(public payload: any) {}
}

export class DoGetAllReplacementOrdersOK implements Action {
    readonly type = MainActionTypes.DO_GET_REPLACEMENTORDERS_OK;

    constructor(public payload: any) {}
}

export class DoGetAllReplacementOrdersKO implements Action {
    readonly type = MainActionTypes.DO_GET_REPLACEMENTORDERS_KO;

    constructor(public payload: any) {}
}

// Feature Options
export class DoGetFeatureOptions implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_OPTIONS;

    constructor(
        public payload: {
            type: string;
            feature: string;
            searchParams: SearchParams;
        }
    ) {}
}

export class DoGetFeatureOptionsOK implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_OPTIONS_OK;

    constructor(public payload: any) {}
}

export class DoGetFeatureOptionsKO implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_OPTIONS_KO;

    constructor(public payload: any) {}
}

// Feature Checks
export class DoGetFeatureChecks implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_CHECKS;

    constructor(
        public payload: {
            type: SearchType;
            searchParams: SearchParams;
        }
    ) {}
}

export class DoGetFeatureChecksOK implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_CHECKS_OK;

    constructor(public payload: { searchFeatureChecks: SearchFeatureChecks }) {}
}

export class DoGetFeatureChecksKO implements Action {
    readonly type = MainActionTypes.DO_GET_FEATURE_CHECKS_KO;

    constructor(public payload: any) {}
}

export class DoResetFeatureChecks implements Action {
    readonly type = MainActionTypes.DO_RESET_FEATURE_CHECKS;
}

// Banners
export class DoGetBanners implements Action {
    readonly type = MainActionTypes.DO_GET_BANNERS;

    constructor(public payload: any) {}
}

export class DoGetBannersOK implements Action {
    readonly type = MainActionTypes.DO_GET_BANNERS_OK;

    constructor(public payload: any) {}
}

export class DoGetBannersKO implements Action {
    readonly type = MainActionTypes.DO_GET_BANNERS_KO;

    constructor(public payload: any) {}
}

// Menu Item
export class DoSetMenuItem implements Action {
    readonly type = MainActionTypes.DO_SET_MENU_ITEM;

    constructor(public payload: { menuItem: any }) {}
}

export class DoSetPreLogin implements Action {
    readonly type = MainActionTypes.DO_SET_PRE_LOGIN_PARAMS;

    constructor(
        public payload: {
            preLogin: RouterState;
        }
    ) {}
}

export class DoSetForceSearchTypeFlag implements Action {
    readonly type = MainActionTypes.DO_SET_FORCE_SEARCH_TYPE_FLAG;

    constructor(
        public payload: {
            forceSearchTypeFlag: boolean;
        }
    ) {}
}

export type MainActions =
    | DoGetInfoInvoices
    | DoGetInfoInvoicesOK
    | DoGetInfoInvoicesKO
    | DoGetInfoOrders
    | DoGetInfoOrdersOK
    | DoGetInfoOrdersKO
    | DoGetBrands
    | DoGetBrandsOK
    | DoGetBrandsKO
    | DoGetAllBrands
    | DoGetAllBrandsOK
    | DoGetAllBrandsKO
    | DoGetAllReplacementOrders
    | DoGetAllReplacementOrdersOK
    | DoGetAllReplacementOrdersKO
    | DoGetFeatureOptions
    | DoGetFeatureOptionsOK
    | DoGetFeatureOptionsKO
    | DoResetFeatureChecks
    | DoGetFeatureChecks
    | DoGetFeatureChecksOK
    | DoGetFeatureChecksKO
    | DoGetBanners
    | DoGetBannersOK
    | DoGetBannersKO
    | DoSetMenuItem
    | DoSetForceSearchTypeFlag;
